import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// Actions
import { actions as userSongActions } from 'modules/usersongs/actions'

// Components
import Beat from 'components/beat/beat'

import type { Beat as BeatType, State, EntityState } from 'types'

import styles from './beatlist.css'

type BeatListProps = {
  userId?: number
}

const BeatList = ({ userId }: BeatListProps) => {
  const dispatch = useDispatch()
  const beats = useSelector<State, EntityState<BeatType>>(state => state.entities.beats)

  useEffect(() => {
    if (userId && userId !== 0) {
      dispatch(userSongActions.fetchBeatByUser(userId))
    }
  }, [userId, dispatch])

  const beatsList = Object.keys(beats || {})
    .map(id => beats[id])
    .filter(beat => beat.visibility === 'public')

  if (!beatsList.length) {
    return null
  }
  return (
    <>
      <h2 className={styles.heading}>Beats</h2>
      <ol className={styles.list}>
        {beatsList.map(beat => (
          <Beat beat={beat} key={beat.id} />
        ))}
      </ol>
    </>
  )
}

export default BeatList
